/** cSpell:disable */

//
// --- Constants ----

const DEFAULT_SUPPLIER_HIERARCHY_COLUMNS = {
  sid0: { field: 'SID0', type: 'FIELD' },
  sname0: { field: 'SNAME0', type: 'FIELD' },
  sid1: { field: 'SID1', type: 'FIELD' },
  sname1: { field: 'SNAME1', type: 'FIELD' },
  sid2: { field: 'SID2', type: 'FIELD' },
  sname2: { field: 'SNAME2', type: 'FIELD' },
  sid3: { field: 'SID3', type: 'FIELD' },
  sname3: { field: 'SNAME3', type: 'FIELD' },
  sid4: { field: 'SID4', type: 'FIELD' },
  sname4: { field: 'SNAME4', type: 'FIELD' },
  sid5: { field: 'SID5', type: 'FIELD' },
  sname5: { field: 'SNAME5', type: 'FIELD' },
  sid6: { field: 'SID6', type: 'FIELD' },
  sname6: { field: 'SNAME6', type: 'FIELD' },
  sid7: { field: 'SID7', type: 'FIELD' },
  sname7: { field: 'SNAME7', type: 'FIELD' },
  sid8: { field: 'SID8', type: 'FIELD' },
  sname8: { field: 'SNAME8', type: 'FIELD' },
  sid9: { field: 'SID9', type: 'FIELD' },
  sname9: { field: 'SNAME9', type: 'FIELD' },
  sid10: { field: 'SID10', type: 'FIELD' },
  sname10: { field: 'SNAME10', type: 'FIELD' }
};

const CONTACT_SPEND_QUERY = {
  columns: {
    firstName: { field: 'FIRSTNAME', type: 'FIELD' },
    lastName: { field: 'LASTNAME', type: 'FIELD' },
    businessTitle: { field: 'BUSINESSTITLE', type: 'FIELD' },
    workPhone: { field: 'WORKPHONE', type: 'FIELD' },
    cellPhone: { field: 'CELLPHONE', type: 'FIELD' },
    emailAddress: { field: 'EMAILADDRESS', type: 'FIELD' },
    poc: {
      type: 'DIVIDE',
      operands: [
        { field: 'POC', type: 'SUM' },
        { fields: ['LOCATIONID'], type: 'COUNT_DISTINCT' }
      ]
    },
    personKey: { field: 'PERSONKEY', type: 'FIELD' },
    addressKey: { field: 'ADDRESSKEY', type: 'FIELD' },
    companyKey: { field: 'COMPANYKEY', type: 'FIELD' },
    personStatusCode: { field: 'PERSONSTATUSCODE', type: 'FIELD' },
    username: { field: 'USERNAME', type: 'FIELD' }
  },
  // prettier-ignore
  groupBy: [
    "SID0", "SNAME0", "SID1", "SNAME1", "SID2", "SNAME2", "SID3", "SNAME3", "SID4", "SNAME4", "SID5", "SNAME5",
    "SID6", "SNAME6", "SID7", "SNAME7", "SID8", "SNAME8", "SID9", "SNAME9", "SID10", "SNAME10",
    "FIRSTNAME", "LASTNAME", "BUSINESSTITLE", "CELLPHONE", "WORKPHONE", "EMAILADDRESS", "PERSONKEY",
    "ADDRESSKEY", "COMPANYKEY", "PERSONSTATUSCODE", "USERNAME"
  ],
  filter: { eq: { SUPPLIERID: '' } },
  sort: []
};

//

/**
 * @typedef {Object} SortListItem
 * @property {('ASC'|'DESC')} direction
 * @property {string} [property]
 *
 * @typedef {Object} BuildSpendQueryOptions
 * @property {any} [spendQuery]
 * @property {readonly SortListItem[]} [sortList]
 * @property {readonly any[]} [filters]
 * @property {boolean} [useDefaultColumns]
 *
 * @param {BuildSpendQueryOptions}
 */
export function buildSpendQuery({ spendQuery = CONTACT_SPEND_QUERY, sortList, filters, useDefaultColumns }) {
  if (spendQuery.columns === undefined) {
    spendQuery.columns = {};
  }

  if (useDefaultColumns) {
    for (const key in DEFAULT_SUPPLIER_HIERARCHY_COLUMNS) {
      spendQuery.columns[key] = DEFAULT_SUPPLIER_HIERARCHY_COLUMNS[key];
    }
  }

  spendQuery.filter = generateFullFilterObject(filters);
  spendQuery.sort = [];
  sortList && sortList.forEach(sortItem => spendQuery.columns[sortItem.property] && spendQuery.sort.push(sortItem));

  return spendQuery;
}

export function generateFullFilterObject(filters) {
  const filterValues = Object.values(filters);

  if (filterValues.length === 1) {
    return filterValues[0];
  }

  if (filterValues.length > 1) {
    return { and: filterValues };
  }

  return null;
}

export function getFrequentContactScoresFilter(buyerCompanyKey, pointOfContactScore) {
  return [
    { or: [{ eq: { BUYERCOMPANYKEY: parseInt(buyerCompanyKey, 10) } }, { isNull: 'BUYERCOMPANYKEY' }] },
    { gt: { POC: pointOfContactScore } }
  ];
}
